module.exports = __webpack_public_path__ + "fonts/Open_Sans-700-vietnamese30.122371a.woff2";